export default __webpack_public_path__ + "static/media/annex10.fbf2456f.png";